import React, {useState, useEffect, createContext, useContext} from 'react';
import uuidv4 from 'uuid/v4';

/** @import { Session } from "./SessionIdTypes" */

export const SessionIdContext = createContext(/** @type {Session | null} */ (null));

/**
 * This session is solely for the purpose of sharing a session ID across
 * LiveChat and Decibel. Don't use this as a shared storage space.
 */

export const withSessionId = (/** @type {React.FC<{ session: Session | null; }>} */ Component) => {
    return (/** @type {object} */ props) => (
        <SessionIdContext.Consumer>
            {context => <Component session={context} {...props} />}
        </SessionIdContext.Consumer>
    );
}

export const useSessionId = () => {
    return /** @type {Session} */ (useContext(SessionIdContext));
}

/** @type {import('./SessionIdTypes').SessionIdComponent} */
export default (props) => {

    let [session] = useState({
        id: props.sessionId || uuidv4()
    });

    useEffect(() => {
        window.digitalData = window.digitalData || {};
        window.digitalData.rae = window.digitalData.rae || {};
        window.digitalData.rae.sessionID = session.id;
    }, [session]);

    return (
        <SessionIdContext.Provider value={session}>
            {props.children}
        </SessionIdContext.Provider>
    );
};

